import { Component } from "@angular/core";
import { FieldType, FieldTypeConfig } from "@ngx-formly/core";

@Component({
    // tslint:disable-next-line:component-selector
    selector: "formly-field-surveycomment",
    styleUrls: ["./common.css"],
    template: `<ng-container>
    <br />
    <mat-form-field appearance="fill" floatLabel="always" class="comments">
      <mat-label>Comments</mat-label>
      <textarea
        rows="4"
        class="form-field"
        matInput
        [formControl]="formControl"
        [formlyAttributes]="field"
        [disabled]="props.disabled"
      ></textarea>
    </mat-form-field>
  </ng-container>`,
    standalone: false
})
export class FormlyFieldSurveyCommentComponent extends FieldType<FieldTypeConfig> {
}
